import {renderer} from 'ln/view/Renderer';
import View from 'ln/view/View';

import {Image} from './Image';


export class ImageView extends View<Image> {

    public constructor() {
        super({ template: '<img>', data: new Image({}) });

        this.data.change.subscribe(this.update.bind(this));
    }

    protected init(): void {
        this.update();
    }

    public update(): void {
        const node = <HTMLElement>this.node;
        if (node) {
            const asset = this.data && this.data.asset;
            if (asset) {
                const {preset, ext} = this.data;
                node.style.backgroundImage = `url("${renderer.context.imageUri(asset, preset, ext)}")`;
            }
            node.classList.toggle(this.data.classIfMissing, !asset);
        }
    }
}
